import { PipelineSourceSyncsPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs')({
  component: PipelineSourceSyncsPage,
});
